var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SalesDashboardCard",
    {
      attrs: {
        title: "Refunds",
        "class-card": "col-md-4",
        "selected-filter": _vm.selectedFilter,
        filters: _vm.filters
      },
      on: { "set-filter": _vm.setFilter }
    },
    [
      _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
        _c("span", {
          staticClass: "dashboard-card-icon dashboard-card-icon-refunds"
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.loading
            ? _c("Loader")
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6 d-flex flex-column" }, [
                  _c("span", { staticClass: "refund-covered-title" }, [
                    _vm._v("Carrier covered")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "refund-value" }, [
                    _vm._v("$ " + _vm._s(_vm.data.carrier_covered))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 d-flex flex-column" }, [
                  _c("span", { staticClass: "refund-covered-title" }, [
                    _vm._v("Office covered")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "refund-value" }, [
                    _vm._v("$ " + _vm._s(_vm.data.office_covered))
                  ])
                ])
              ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa6f720c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa6f720c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/Refunds.vue
// module id = null
// module chunks = 